import { QueryParams, makeAPIRequest } from '../utils/request'
import { Badge } from './badges.types'

/**
 * Fetch single badge by user and badge Id
 */
export const fetchBadgeInfo = async (
  userId: string,
  badgeCode: string
): Promise<Badge | null> => {
  let headerParams: QueryParams = {}
  headerParams.Authorization = `Bearer ${process.env.REACT_APP_API_ACCESS_KEY}` || ''
  const route = `users/${userId}/badge/${badgeCode}/info`
  try {
    const badgeRes = await makeAPIRequest(route, {
      method: 'GET',
      apiVersion: '1',
      headerParams,
    })
    if (!badgeRes?.data || badgeRes?.error) {
      console.error(badgeRes.error?.message)
      return null
    }
    return badgeRes.data
  } catch (err) {
    console.error(`Failed to fetch single badge with badge id: ${badgeCode}`)
    return null
  }
}
